// 中文翻译
export default {
  welcome: '欢迎',
  tapToUnmute: '点击取消静音',
  likeHint: '喜欢请点赞',
  previousEpisode: '上一集',
  nextEpisode: '下一集',
};

